module.exports = __webpack_public_path__ + "img/nav_1.4703521e.png";